import React from 'react'

import ROUTE from 'constant/route'
import { IRoute } from 'interfaces'
import AdminLayout from './layouts/AdminLayout'
import AppBarLayout from './layouts/AppBarLayout'
import nameof from 'utilities/nameof'
import { ClientType, OperationalSettingContract } from 'models'
import OrderDashboardLayout from './layouts/OrderDashboardLayout'
import LazyRetry from 'components/LazyRetry/LazyRetry'
import { MODULE_SALES } from 'constant/permissions'

const QuickSalePage = LazyRetry(() => import('pages/SellPage/QuickServicePage'))
const OrderQueuePage = LazyRetry(
    () => import('pages/OrderQueuePage/OrderQueuePage'),
)
const OrderDashboardPage = LazyRetry(
    () => import('pages/OrderDashboardPage/OrderDashboardPage'),
)
const TableServicePage = LazyRetry(
    () => import('pages/TableServicePage/TableServicePage'),
)
const CashDrawerPage = LazyRetry(
    () => import('pages/PosCashTerminalPage/CashDrawerTerminalPage'),
)
const PosTerminalPage = LazyRetry(
    () => import('pages/PosTerminalPage/PosTerminalPage'),
)
const OrderLoaderPage = LazyRetry(
    () => import('pages/OrderLoaderPage/OrderLoaderPage'),
)
const OPERATION_SETTINGS = nameof<OperationalSettingContract>()

/**
 * please stay Admin route to last
 * because it exact route "/"
 */
export enum AuthRouteName {
    tableService = 'tableSales',
    quickSale = 'quickSale',
    orderQueue = 'orderQueue',
    posTerminal = 'posTerminal',
    cashDrawer = 'cashDrawer',
    orderDashboard = 'orderDashboard',
    OrderLoaderPage = 'OrderLoaderPage',
    /**
     * other route upper admin
     */
    admin = 'admin',
}
type IRouteConstant = {
    [routeName in AuthRouteName]: IRoute
}

const ComponentWithAppBar = (children: any, hasCard = true) => (
    <AppBarLayout hasCardBg={hasCard}>{children}</AppBarLayout>
)

const ComponentOrderDashboardAppBar = (children: any) => (
    <OrderDashboardLayout>{children}</OrderDashboardLayout>
)

export const AuthRoute: IRouteConstant = {
    OrderLoaderPage: {
        path: ROUTE.ORDERS,
        component: OrderLoaderPage,
        requirePermission: MODULE_SALES,
        visibleToClientType: [
            ClientType.PosTerminalWithOutCash,
            ClientType.PosTerminalWithCash,
        ],
    },
    tableSales: {
        path: ROUTE.TABLE_SERVICE,
        component: TableServicePage,
        requirePermission: MODULE_SALES,
        moduleName: OPERATION_SETTINGS.tableSales,
        visibleToClientType: [
            ClientType.PosTerminalWithOutCash,
            ClientType.PosTerminalWithCash,
        ],
    },
    quickSale: {
        path: ROUTE.QUICK_SERVICE,
        component: QuickSalePage,
        requirePermission: MODULE_SALES,
        moduleName: OPERATION_SETTINGS.quickSales,
        visibleToClientType: [
            ClientType.PosTerminalWithOutCash,
            ClientType.PosTerminalWithCash,
        ],
    },
    orderQueue: {
        path: ROUTE.ORDER_QUES,
        component: () => ComponentWithAppBar(<OrderQueuePage />, false),
        requirePermission: [],
        visibleToClientType: [
            ClientType.PosTerminalWithOutCash,
            ClientType.PosTerminalWithCash,
            ClientType.OrderQuesTerminal,
        ],
    },
    posTerminal: {
        path: ROUTE.POS_TERMINAL,
        component: PosTerminalPage,
        requirePermission: [],
        terminalSetting: 'openTerminal',
        visibleToClientType: [
            ClientType.PosTerminalWithCash,
            ClientType.PosTerminalWithOutCash,
        ],
    },
    cashDrawer: {
        path: ROUTE.CASH_DRAWER_TERMINAL,
        component: CashDrawerPage,
        requirePermission: [],
        terminalSetting: 'openTerminal',
        visibleToClientType: [
            ClientType.PosTerminalWithCash,
            ClientType.PosTerminalWithOutCash,
        ],
    },
    orderDashboard: {
        path: ROUTE.ORDER_DASHBOARD,
        moduleName: OPERATION_SETTINGS.orderDashboard,
        component: () => ComponentOrderDashboardAppBar(<OrderDashboardPage />),
        requirePermission: [],
        visibleToClientType: [
            ClientType.PosTerminalWithCash,
            ClientType.PosTerminalWithOutCash,
            ClientType.OrderQuesTerminal,
        ],
    },
    admin: {
        path: ROUTE.MAIN,
        exact: true,
        component: AdminLayout,
        requirePermission: [],
    },
}
